import React, { useCallback, useEffect, useState } from "react";
import styles from "./index.module.css";
import ReportTablePacing from "Reporting/Components/ReportTablePacing";
import { usePacingGet } from "./usePacingGet";
import Loader from "shared/Loader";

export default function ReportTableListPacing({
  filters,
  setReportsLength,
  setReportData,
  fetchTrigger,
}) {
  const { data, isLoading, isError, refetch } = usePacingGet(filters);
  const [report, setReport] = useState(null);
  const rows = Array.isArray(report?.rows) ? report.rows : [];

  useEffect(() => {
    if (typeof fetchTrigger !== "undefined") {
      refetch?.();
    }
  }, [fetchTrigger]);

  useEffect(() => {
    if (!data) return;

    const sortedRows = [...(data.rows || [])].sort(
      (a, b) => Number(b.isTotalRow) - Number(a.isTotalRow)
    );
    const nextReport = { ...data, rows: sortedRows };
    setReport(nextReport);
    setReportsLength?.(sortedRows.length > 0 ? 1 : 0);
    setReportData?.(nextReport);
  }, [data]);

  const handleSortedRowsChange = useCallback((sortedRows) => {
    setReport((current) => {
      if (!current) return current;
      if (JSON.stringify(current.rows) === JSON.stringify(sortedRows)) {
        return current;
      }
      const nextReport = { ...current, rows: sortedRows };
      setReportData?.(nextReport);
      return nextReport;
    });
  }, [setReportData]);

  if (isError) return <div>Something went wrong...</div>;
  if (isLoading) return <Loader />;
  if (rows.length === 0) return <div>No Reports Found</div>;

  return (
    <div className={styles.container}>
      <ReportTablePacing
        report={report}
        onSortedRowsChange={handleSortedRowsChange}
      />
    </div>
  );
}